<template>
	<div>
		<!-- start TL Search form script -->
		<div id="block-search">
			<div id="tl-search-form" class="tl-container">
				<a href="#" rel="nofollow" target="_blank">&nbsp;</a>
			</div>
		</div>
		<!-- end TL Search form script -->
	</div>
</template>

<script>

export default {
	mounted() {
		const script = document.createElement('script');
		script.src = '/tl_integration.js';
		script.async = true;
		document.head.appendChild(script);

		// Yandex.Metrika goal: Track "Найти" button click in TravelLine widget
		this.observeTLButton();
	},
	beforeUnmount() {
		console.log('beforeUnmount:');
		const scripts = Array.from(document.querySelectorAll('script[src="/tl_integration.js"]'));
		console.log('scripts:', scripts);
		scripts.forEach(s => s.remove());
		if (this._tlObserver) {
			this._tlObserver.disconnect();
		}
	},
	name: "TravelLineSearchFormComponent",
	methods: {
		observeTLButton() {
			/* eslint-disable no-undef */
			const trackSearch = () => {
				if (typeof ym === 'function') {
					ym(109723241, 'reachGoal', 'travelline_search');
				}
			};
			const trackSelect = () => {
				if (typeof ym === 'function') {
					ym(109723241, 'reachGoal', 'travelline_select');
				}
			};
			const trackBooking = () => {
				if (typeof ym === 'function') {
					ym(109723241, 'reachGoal', 'travelline_booking');
				}
			};

			const findButtons = (root) => {
				const buttons = root.querySelectorAll('button, [role="button"], input[type="submit"], a');
				buttons.forEach(btn => {
					const text = (btn.textContent || btn.value || '').toLowerCase().trim();
					if ((text === 'найти' || text.includes('найти')) && !btn.dataset.tlTrackedSearch) {
						btn.dataset.tlTrackedSearch = '1';
						btn.addEventListener('click', trackSearch);
					}
					if ((text === 'выбрать' || text.includes('выбрать')) && !btn.dataset.tlTrackedSelect) {
						btn.dataset.tlTrackedSelect = '1';
						btn.addEventListener('click', trackSelect);
					}
					if ((text === 'забронировать' || text.includes('забронировать')) && !btn.dataset.tlTrackedBooking) {
						btn.dataset.tlTrackedBooking = '1';
						btn.addEventListener('click', trackBooking);
					}
				});
			};

			// Initial pass
			setTimeout(() => findButtons(document), 3000);

			// Watch for dynamic content
			this._tlObserver = new MutationObserver(() => {
				findButtons(document);
			});
			this._tlObserver.observe(document.body, {
				childList: true,
				subtree: true,
			});
		},
	},
}
</script>

<style>
/*<!-- start TL Search form script -->*/
#block-search,
#block-search * {
	box-sizing: border-box;
}

#block-search {
	max-width: 967px;
	width: 80%;
	margin: 0 auto;
}

.tl-container {
	background: #F7F3ED;
	border-radius: 8px;
	box-shadow: 0px 0px 10px 0px rgba(44, 51, 51, 0.1);
}
/*<!-- end TL Search form script -->*/
</style>